import {
  Box,
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalProps,
  Text,
} from '@ritualco/jutsu'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'

export type PaymentMethodDeleteModalProps = {
  onSubmit: () => void
  isDescriptive?: boolean
} & Omit<ModalProps, 'children'>

export const PaymentMethodDeleteModal = ({
  isOpen,
  onClose,
  onSubmit,
  isDescriptive = false,
  ...modalProps
}: PaymentMethodDeleteModalProps) => {
  const { formatMessage } = useContent()

  return (
    <HeraModal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      isCentered={true}
      {...modalProps}
    >
      <ModalHeader {...(!isDescriptive && { mb: 3 })}>
        {formatMessage({ id: 'pmportal.billing.deleteCardTitle' })}
      </ModalHeader>
      {isDescriptive && (
        <ModalBody>
          <Box color="grayscale.secondary">
            {formatMessage(
              { id: 'pmportal.billing.deleteCardDescription' },
              { p: text => <Text _notFirst={{ paddingTop: 6 }}>{text}</Text> }
            )}
          </Box>
        </ModalBody>
      )}
      <ModalFooter>
        <Button colorScheme="transparent" mr={2} onClick={onClose}>
          {formatMessage({ id: 'pmportal.global.actionCancel' })}
        </Button>
        <Button
          type="submit"
          colorScheme="red"
          onClick={async () => {
            await onSubmit()
            onClose()
          }}
        >
          {formatMessage({ id: 'pmportal.global.actionRemove' })}
        </Button>
      </ModalFooter>
    </HeraModal>
  )
}
